import React from 'react';
import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';

export const Tabs = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: inset 0 -1px 0 0 ${p => p.theme.lines.secondary};

  ${media.mediumDown`
    max-width: 100vh;
    overflow-x: auto;
  `};
`;

type TabProps = {
  active?: boolean;
  to?: string;
};

export const TabLink = styled(({ active, ...rest }) => <Link {...rest} />)<
  TabProps
>`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 ${layout.measurements.spacingNormal};
  font-weight: 600;
  cursor: pointer;
  color: ${props => props.theme.colors.base500};
  transition: box-shadow 0.1s linear;
  white-space: nowrap;

  a:hover,
  &:hover {
    color: ${props => props.theme.colors.base600};
  }

  ${props =>
    props.active &&
    css`
      box-shadow: inset 0 -5px 0 -1px ${p => p.theme.colors.yellove500};
      color: ${p => p.theme.text.primary};

      a:hover,
      &:hover {
        color: inherit;
      }
    `};
`;

export const Image = styled.div`
  margin-right: ${layout.measurements.spacingSmall};
`;
